import { createTheme, alpha } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#B62EA0",
      light: "#AB68AC",
      dark: "#5F1C69",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#FFD233",
      light: "#FFF4CC",
      dark: "#B39324",
      contrastText: "rgba(0,0,0,0.87)",
    },
    info: { main: "#8DCFFF" },
    success: { main: "#87E39C" },
    background: {
      default: "#FFFFFF",
      paper: "#F5F5F5",
    },
    text: {
      primary: "#222A22",
      secondary: "rgba(0,0,0,0.6)",
    },
  },
  typography: {
    fontFamily: "Rubik, sans-serif",
    h3: { fontFamily: "Rubik, sans-serif", fontWeight: 300 },
    h4: { fontFamily: "Rubik, sans-serif", fontWeight: 300 },
    body1: { fontFamily: "Rubik, sans-serif" },
    subtitle1: { fontFamily: "Rubik, sans-serif" },
    button: {
      textTransform: "none",
      fontFamily: "Rubik, sans-serif",
      fontWeight: 500,
    },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: (t) => ({
        "*, *::before, *::after": { boxSizing: "border-box" },
        html: { scrollBehavior: "smooth" },
        body: {
          backgroundColor: t.palette.background.default,
        },
        "::-webkit-scrollbar": { width: 10, height: 10 },
        "::-webkit-scrollbar-thumb": {
          background: alpha("#B62EA0", 0.35),
          borderRadius: 999,
        },
      }),
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 18,
          paddingBlock: 10,
          fontWeight: 600,
        },
        containedPrimary: {
          backgroundImage: "linear-gradient(-10deg, #ffa633 0%, #FFD233 100%)",
          color: "#222",
          boxShadow: "0 2px 2px #222",
          "&:hover": {
            filter: "brightness(0.95)",
            boxShadow: "0 1px 1px #222",
          },
        },
        containedSecondary: {
          backgroundColor: "#FFD233",
          color: "rgba(0,0,0,0.87)",
          "&:hover": { backgroundColor: "#F5C81F" },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backdropFilter: "blur(8px)",
          borderRadius: 999,
        },
        filledSecondary: {
          backgroundColor: alpha("#FFF4CC", 0.8),
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { height: 4, borderRadius: 999 },
        colorPrimary: { backgroundColor: alpha("#B62EA0", 0.15) },
        barColorPrimary: {
          backgroundImage: "linear-gradient(90deg, #B62EA0, #FFD233)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 16 },
      },
    },
  },
});
